/** This component is used when the server tries to render a path that is guarded */
import { Component } from '@angular/core';

@Component({
  selector: 'app-guarded',
  templateUrl: './guarded.component.html',
  standalone: false,
})
export class GuardedComponent {}
